/*
 * Copyright (c) 2020 General Electric Company. All rights reserved.
 *
 * The copyright to the computer software herein is the property of
 * General Electric Company. The software may be used and/or copied only
 * with the written permission of General Electric Company or in accordance
 * with the terms and conditions stipulated in the agreement/contract
 * under which the software has been supplied.
 */

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataValidationService {
  private prefixRegex = /.[%*]$/;
  private suffixRegex = /^[%*]/;
  private validCkeyRegex = /^[0-9]+$/;
  private sqlInjectionChar = /(<|%3c|&lt)script|(^')|('$)|(--)|(';)/gi;

  hasInvalidWildcardsFormat(searchCriteria, notAllowedSuffixSearch?) {
    const notSupportedCharSequence = this.hasNonSupportedPattern(searchCriteria);
    let isSuffixNotSupported;

    // this handling is  for attribute  that they don't allow suffix search
    if (!!notAllowedSuffixSearch) {
      const reg = /[%*].+/;
      isSuffixNotSupported = reg.test(searchCriteria);
    }
    return notSupportedCharSequence || !!isSuffixNotSupported;
  }

  // this method is to handle the non supported sequence
  hasNonSupportedPattern(searchCriteria) {
    // if the search Criteria contains more than 2 special characters like *1234*
    // or contain one special char which is in between like 12%34
    // the search should not be allowed and we will show  an  error message

    // Check for multiple wildcards: has at least 2 occurrences of * or %
    const wildcardCount = (searchCriteria.match(/[*%]/g) || []).length;
    if (wildcardCount >= 2) {
      return true;
    }

    // Check for single wildcard in the middle (not at start or end)
    // Fixed ReDoS vulnerability by using indexOf instead of vulnerable regex
    const wildcardIndex = searchCriteria.search(/[*%]/);
    return wildcardIndex > 0 && wildcardIndex < searchCriteria.length - 1;
  }

  //this method to handle special charter check which cause a sql injection
  hasSqlInjectionChar(searchCriteria) {
    return searchCriteria.match(this.sqlInjectionChar);
  }

  // this method is used to verify if the string contain a special character
  hasSpecialChar(searchCriteria) {
    const specialChars = '<>@!#&()[]{}?:;|"\\/~`=';
    for (const specialChar of specialChars) {
      if (!!searchCriteria && searchCriteria.indexOf(specialChar) > -1) {
        return true;
      }
    }
    return false;
  }

  // this method is used to test if the user search for prefix match
  // it will return true if the user input are invalid
  isInvalidPrefix(searchCriteria, prefixLength) {
    const isPrefix = this.prefixRegex.test(searchCriteria);
    return isPrefix && searchCriteria.length <= prefixLength;
  }

  isInvalidSuffix(searchCriteria, suffixLength) {
    const isValidSuffixPatern = this.suffixRegex.test(searchCriteria);
    return isValidSuffixPatern && searchCriteria.length !== parseInt(suffixLength, 10) + 1;
  }

  isSuffixTooShort(searchCriteria, suffixLength) {
    const isValidSuffixPatern = this.suffixRegex.test(searchCriteria);
    return isValidSuffixPatern && searchCriteria.length < parseInt(suffixLength, 10) + 1;
  }

  isSuffixTooLong(searchCriteria, suffixLength) {
    const isValidSuffixPatern = this.suffixRegex.test(searchCriteria);
    return isValidSuffixPatern && searchCriteria.length > parseInt(suffixLength, 10) + 1;
  }

  isValidCkeyInput(inputValue) {
    return this.validCkeyRegex.test(inputValue);
  }
}
